import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import editDateIcon from "../../../assets/editDate.png";
import OrderTable, { formatarValor } from "../../../components/OrderTable";
import OrderDetails from "../../../components/OrderDetails";

import Pagination from "@mui/material/Pagination";
import useOrdersStore from "../../../store/ordersStore";
import useOrderItemsStore from "../../../store/orderItemsStore";

const Pedidos = () => {
  const { orders, getAllOrders, loading, error } = useOrdersStore();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );

  useEffect(() => {
    getAllOrders();
  }, [getAllOrders]);

  const years = [2030, 2029, 2028, 2027, 2026, 2025, 2024, 2023, 2022, 2021];
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleYearSelect = (year) => {
    setSelectedYear(year);
    setIsOpen(false);
  };

  const [quantiyTotalOrders, setQuantityTotalOrdes] = useState(0);
  const [totalOrder, setTotalOrder] = useState(0);
  const [amountToPay, setAmountToPay] = useState(0);

  const filteredOrders = orders.filter((order) => {
    const orderYear = new Date(order.createdAt).getFullYear();
    return orderYear === parseInt(selectedYear);
  });

  const currentOrders = filteredOrders;
  const navigate = useNavigate();
  const { clearOrderItems } = useOrderItemsStore();
  useEffect(() => {
    setQuantityTotalOrdes(filteredOrders.length);
    setTotalOrder(
      filteredOrders.reduce(
        (total, order) => total + parseFloat(order.order_total),
        0
      )
    );

    setAmountToPay(
      filteredOrders.reduce(
        (total, order) => total + parseFloat(order.amount_left),
        0
      )
    );
  }, [filteredOrders]);

  const handleNavigate = () => {
    clearOrderItems();
    navigate("/pedidos/novo-pedido");
  };

  if (loading) return <h1>Carregando...</h1>;
  // if (error) return <h1>{error}</h1>;
  return (
    <>
      <div className="flex justify-between h-[40px] my-2">
        <div className="md:w-[150px] lg:w-[180px]  2xl:w-[210px]">
          <CustomButton
            onClick={handleNavigate}
            className="bg-primary text-white font-semibold text-base md:text-sm xl:text-base"
          >
            Novo pedido
          </CustomButton>
        </div>

        <div className="relative z-[1000]">
          <button
            onClick={toggleDropdown}
            className="flex items-center h-[40px]"
          >
            <img className="h-[30px] w-[30px]" src={editDateIcon} alt="" />
            <span className="font-semibold w-[120px] text-center px-8 py-2 text-[#FF9533] bg-[#F2F2F2] rounded-md ml-4">
              {selectedYear}
            </span>
          </button>
          {isOpen && (
            <ul className="absolute mt-2 bg-white shadow-md rounded-md border border-gray-300 w-[120px]">
              {years.map((year) => (
                <li
                  key={year}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleYearSelect(year)}
                >
                  {year}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <OrderTable orders={currentOrders} />

      <OrderDetails
        qtd={quantiyTotalOrders}
        total={formatarValor(totalOrder, "USD")}
        valor={formatarValor(amountToPay, "USD")}
      />
    </>
  );
};

export default Pedidos;
